import { useEffect, useMemo, useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { api } from "../../lib/api";
import { useStaff } from "./StaffLayout";
import { ScheduleCard } from "./StaffHome";

export default function StaffSchedule() {
  const { t } = useStaff();
  const now = new Date();
  const [year, setYear] = useState(now.getFullYear());
  const [month, setMonth] = useState(now.getMonth() + 1);
  const [schedules, setSchedules] = useState([]);

  const range = useMemo(() => {
    const last = new Date(year, month, 0).getDate();
    const mm = String(month).padStart(2, "0");
    return { from: `${year}-${mm}-01`, to: `${year}-${mm}-${String(last).padStart(2, "0")}` };
  }, [year, month]);

  const load = () => {
    api.get("/staff/schedules", { params: { date_from: range.from, date_to: range.to } }).then((r) => setSchedules(r.data)).catch(() => setSchedules([]));
  };
  useEffect(load, [range]);

  const move = (delta) => {
    let m = month + delta;
    let y = year;
    if (m < 1) { m = 12; y -= 1; }
    if (m > 12) { m = 1; y += 1; }
    setYear(y);
    setMonth(m);
  };

  const grouped = useMemo(() => {
    const map = {};
    schedules.forEach((s) => {
      (map[s.date] = map[s.date] || []).push(s);
    });
    return Object.entries(map).sort(([a], [b]) => a.localeCompare(b));
  }, [schedules]);

  return (
    <div data-testid="staff-schedule-page" className="mx-auto max-w-lg px-4 py-6">
      <div className="flex items-center justify-between">
        <button data-testid="staff-schedule-prev" onClick={() => move(-1)} className="border border-line p-2 text-gray-400 hover:border-accent hover:text-accent"><ChevronLeft className="h-5 w-5" /></button>
        <h2 data-testid="staff-schedule-title" className="font-mincho text-lg font-bold text-white">{year}/{month} {t("month_schedule")}</h2>
        <button data-testid="staff-schedule-next" onClick={() => move(1)} className="border border-line p-2 text-gray-400 hover:border-accent hover:text-accent"><ChevronRight className="h-5 w-5" /></button>
      </div>

      <div className="mt-5 space-y-5">
        {grouped.length === 0 && <p data-testid="staff-schedule-empty" className="py-10 text-center text-sm text-gray-500">{t("no_plans")}</p>}
        {grouped.map(([date, list]) => (
          <div key={date}>
            <p className="mb-2 border-b border-line pb-1 font-mono text-sm font-bold text-accent">{date}</p>
            <div className="space-y-3">
              {list.map((s) => <ScheduleCard key={s.id} s={s} t={t} showReport={false} />)}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
